import Vue from "vue";
export default Vue.extend({
  name: "ValueSection",
  props: {
    calculationValue: {
      type: Object,
      required: true
    },
    explanationExists: {
      type: Boolean,
      required: true
    },
    popoverWindowOptions: {
      type: Object,
      required: true
    },
    valueText: {
      type: String,
      required: true
    }
  }
});